import AllowedFeature from '@pkgs/shared/enums/AllowedFeature';
import SubscriptionTier from '@pkgs/shared/enums/SubscriptionTier';
import subscriptionTiersHasSubscriptionTierPrivileges from '@pkgs/shared/helpers/subscriptionTiersHasSubscriptionTierPrivileges';

// Minimum required subscription tier to have access to a feature
export const PERMISSION_MAP = {
	[AllowedFeature.PRIVATE_ITEM]: SubscriptionTier.PRO,
	[AllowedFeature.PRIVATE_BOARD]: SubscriptionTier.PRO,
	[AllowedFeature.SHARED_BOARD]: SubscriptionTier.PRO,
	[AllowedFeature.PRINT]: SubscriptionTier.PRO,
	[AllowedFeature.RIGHT_CLICK]: SubscriptionTier.PRO,
	[AllowedFeature.AUTO_PLAY_GIF]: SubscriptionTier.STARTER,
	[AllowedFeature.DROPBOX_BACKUP]: SubscriptionTier.PRO,
	[AllowedFeature.PRINT_GRID]: SubscriptionTier.PRO,
	[AllowedFeature.FULL_FEED]: SubscriptionTier.STARTER,
	[AllowedFeature.MANAGE_TEAM]: SubscriptionTier.TEAM,
	[AllowedFeature.CREATE_SITE]: SubscriptionTier.SITE_MAKER,
	[AllowedFeature.HIDE_ASSETS]: SubscriptionTier.PRO,
	[AllowedFeature.HIDE_BOARD]: SubscriptionTier.PRO,
} as const;

export default function hasAllowedFeatureFromSubscriptionTiers(
	subscriptionTiers: ValueOf<typeof SubscriptionTier>[],
	feature: Exclude<
		ValueOf<typeof AllowedFeature>,
		typeof AllowedFeature.ADD_ITEM | typeof AllowedFeature.ADD_BOARD
	>,
) {
	const subscriptionTier = PERMISSION_MAP[feature];

	return subscriptionTiersHasSubscriptionTierPrivileges(subscriptionTiers, subscriptionTier);
}
